import React, { Component } from 'react';
import PageHeader from '../components/PageHeader/PageHeader';
import MobileHeader from '../components/MobileHeader/MobileHeader';
import PageMenu from '../components/PageMenu/PageMenu';
import TouchLink from '../components/TouchLink';
import Immutable from 'immutable';
import { firebaseRoot } from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import { Router, Route } from 'react-router';

function bookImage(book) {
	let id = book['.key'].toString();
	let subdir = id.substring(id.length - 3);
	return `http://www.smakprov.se/l/${subdir}/${book['.key']}.png`;
}

const BookList = React.createClass({
	mixins: [ReactFireMixin],

	componentWillMount() {
		this.bindAsArray(firebaseRoot.child("content/books"), "books");
	},

	render() {

		const loc = window.location.pathname;
		let path = '';

		if(loc === '/assessment') {
			path = '/assessment';
		} else if(loc === '/lesson') {
			path = '/lesson'
		} else {
			path = '/book';
		}

		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='default'
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<div className="container">
						<div className="row">
							<div className="col-xs-12">
								<h1>Böcker</h1>
								<div className="books">
									{
										this.state.books.map(book => <TouchLink className="book-link" key={book['.key']}
										                                        to={`${path}/${book['.key']}/chapters`}>
											<article className="book">
												<div className="book-img">
													<img src={bookImage(book)}/>
												</div>
												<div className="book-info">
													<p className="book-info-p">{book.level}</p>
													<h2 className="book-info-head">{book.title}</h2>
												</div>
											</article>
										</TouchLink>)
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		);
	}
});

export default BookList;



/** WEBPACK FOOTER **
 ** ./src/screens/BookList.js
 **/